import {
  RequestResponse,
  WalletResponse,
  BalanceRequestData,
  BalanceLimitResponse,
  LimitMonitoringResponse,
  BalanceMonitoringParams,
  GetBalanceHistoryRequest,
  LimitOrBalanceUpdateData,
  BalanceMonitoringResponse,
  GetBalanceMonitoringRequest,
  LimitMonitoringRequestParams,
  BalanceTransactionRequestData,
  BalanceTransactionRequestResponse,
  CashInOrCashOutBalanceRequestData,
} from "../../../models";
import { BaseApiService } from "../../base-api-service";
import { DEFAULT_HEADERS } from "../../../services";
import { combineQuery } from "../../../helpers";
import { ApiVersions } from "../../../enums";
import { env } from "../../../environment";

class WalletController extends BaseApiService {
  public async getWallet(userId: number): Promise<WalletResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/${userId}`;
    return await this.http.get(url);
  }

  public async getBalanceHistory(
    params: GetBalanceHistoryRequest,
  ): Promise<BalanceLimitResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-history`;
    return await this.http.post(url, params);
  }

  public async getLimitHistory(params: GetBalanceHistoryRequest): Promise<BalanceLimitResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-history`;
    return await this.http.post(url, params);
  }

  public async updateLimit(
    userId: number,
    data: LimitOrBalanceUpdateData,
  ): Promise<WalletResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-add/${userId}`;
    return await this.http.put(url, data);
  }

  public async removeLimit(
    userId: number,
    data: LimitOrBalanceUpdateData,
  ): Promise<WalletResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-remove/${userId}`;
    return await this.http.put(url, data);
  }

  public async updateBalance(userId: number, data: LimitOrBalanceUpdateData): Promise<WalletResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-transfer/${userId}`;
    return await this.http.put(url, data);
  }

  public async removeBalance(userId: number, data: LimitOrBalanceUpdateData): Promise<WalletResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-take/${userId}`;
    return await this.http.put(url, data);
  }

  public async balanceTransaction(params: BalanceTransactionRequestData): Promise<BalanceTransactionRequestResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-request`;
    return await this.http.post(url, params);
  }

  public async balanceRequestApproveOrReject(data: BalanceRequestData): Promise<BalanceTransactionRequestResponse> {
    let url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-request`;
    return await this.http.put(url, data);
  }

  public async cashOutBalance(data: CashInOrCashOutBalanceRequestData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/cash-out`;
    return await this.http.put(url, data);
  }

  public async cashInBalance(data: CashInOrCashOutBalanceRequestData): Promise<void> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/cash-in`;
    return await this.http.put(url, data);
  }

  public async getBalanceMonitoringTransactions(params: BalanceMonitoringParams): Promise<BalanceMonitoringResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-history`;
    return await this.http.get(url, {params});
  }

  public async getLimitMonitoringTransactions(params: LimitMonitoringRequestParams): Promise<LimitMonitoringResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-history`;
    return await this.http.get(url, {params});
  }

  public async getRequests(params: GetBalanceMonitoringRequest): Promise<RequestResponse> {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-request`;
    return await this.http.get(url, { params });
  }

  public async exportBalanceHistoryExcel(params: GetBalanceMonitoringRequest) {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-history-export-excel`;
    return await fetch(`${url}${combineQuery(params)}`, {
      credentials: 'include',
      headers: {
        ...DEFAULT_HEADERS
      }
    });
  }

  public async exportBalanceHistoryCsv(params: GetBalanceMonitoringRequest) {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/balance-history-export-csv`;
    return await fetch(`${url}${combineQuery(params)}`, {
      credentials: 'include',
      headers: {
        ...DEFAULT_HEADERS
      }
    });
  }

  public async exportLimitHistoryExcel(params: LimitMonitoringRequestParams) {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-history-export-excel`;
    return await fetch(`${url}${combineQuery(params)}`, {
      credentials: 'include',
      headers: {
        ...DEFAULT_HEADERS
      }
    });
  }

  public async exportLimitHistoryCsv(params: LimitMonitoringRequestParams) {
    const url = `${this.url}/api/${ApiVersions.V1}/walletApi/limit-history-export-csv`;
    return await fetch(`${url}${combineQuery(params)}`, {
      credentials: 'include',
      headers: {
        ...DEFAULT_HEADERS
      }
    });
  }

}

export const walletController = new WalletController({ url: env.httpUrl });
